import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Message = styled.p`
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.25rem;
  margin: 0;
`;

const Title = styled.p`
  font-size: 1.125rem;
  line-height: 1.5rem;
`;

const Wrapper = styled.div`
  border: 0.0625rem solid ${({ theme }) => theme.themeColors.success};
  border-radius: 0.75rem;
  margin: 1rem 0 0;
  padding: 1.75rem;
`;

function CancelledMessage({ cancellationFee }) {
  return (
    <Wrapper>
      <Title>Your Appointment Was Canceled</Title>
      <Message>
        {`We cancelled your appointment with a fee of $${cancellationFee}`}
      </Message>
    </Wrapper>
  );
}

CancelledMessage.propTypes = {
  cancellationFee: PropTypes.number.isRequired,
};

export default CancelledMessage;
